import { EntityStatusBadgeVariant } from '@frontend/common';
import { CommonMessage } from '@frontend/lang';
import { JobState } from '@frontend/report/types';
import React from 'react';

import { JobStateBadgeProps } from './job-state-badge.component';

interface ViewProps {
    displayName: React.ReactNode;
    variant: EntityStatusBadgeVariant;
}

export const useJobStateBadge = (props: JobStateBadgeProps): ViewProps => {
    return {
        displayName: JobState.getByValue(props.state)?.displayName || CommonMessage.OBJECTS.UNKNOWN.DEFAULT,
        variant: JobState.getBadgeVariant(props.state)
    };
};
